module.exports = ".col-xs-11, .col-xs-1 {\n\tpadding: 0px;\n}\n.col-xs-1 span {\n\tpadding-top: 5px;\n}\n.sha-check {\n\tmargin-top: 10px;\n}\n.col-xs-1 .fa-question-circle {\n    vertical-align: text-bottom;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/signup.component.css
// module id = 1571
// module chunks = 0